import { fetchAddressList, fetchSearchHotWords, fetchUserCouponDetail, fetchGetCouponHold, fetchCouponList } from '@/services';
import { HotWordType } from '@/types';
import type { Search } from '@/types/global-business';
import { defineStore } from 'pinia';

interface State {
  /** 优惠券渲染配置信息缓存 */
  couponConfigCache: AnyObject | null;
  /** 搜索热词 */
  searchHotWords: Search.HotWord[];
  /** 地址列表数据 */
  addressList: any[];
  /** 修改地址时显示的地址 */
  displayedAddress: AnyObject | null;
  /** 选定地址后的回调函数 */
  selectedAfterCallback: ((selectedItem: AnyObject) => void) | null;
  /** 优惠券相关公用数据 */
  coupon: {
    /** 未使用的优惠券列表数据 */
    unusedCouponList: AnyObject[];
    /** 优惠券详情数据 */
    couponDetail: AnyObject | null;
    /** 用户的优惠券数据 */
    userCoupon: AnyObject | null;
    /** 优惠券持有信息 */
    couponHold: AnyObject | null;
  }
}

export const useCommonStore = defineStore('common', {
  state: (): State => ({
    /** 优惠券渲染配置信息缓存 */
    couponConfigCache: null,
    /** 搜索热词 */
    searchHotWords: [],
    /** 地址列表数据 */
    addressList: [],
    /** 修改地址时顶部显示的地址 */
    displayedAddress: null,
    /** 选定地址后的回调函数 */
    selectedAfterCallback: null,

    /** 优惠券相关公用数据 */
    coupon: {
      /** 未使用的优惠券列表数据 */
      unusedCouponList: [],
      /** 优惠券详情数据 */
      couponDetail: null,
      /** 用户的优惠券数据 */
      userCoupon: null,
      /** 优惠券持有信息 */
      couponHold: null
    },
  }),
  getters: {
    defaultAddress({ addressList }: State) {
      return (
        (addressList ?? []).find((it) => it?.defaultShippingAddress) ?? addressList?.[0] ?? null
      );
    },
    isShareable(state) {
      if (state.coupon.couponDetail?.isShareable === false) {
        return false;
      }
      return true;
    },
  },
  actions: {
    /** 获取地址列表 */
    async getAddressList(refresh?: boolean) {
      if (!this.addressList.length || refresh) {
        const data = await fetchAddressList();
        if (data) this.addressList = data;
      }
      return this.addressList;
    },
    // 获取搜索热词
    async getSearchHotWords() {
      const data = await fetchSearchHotWords();
      if (data) {
        const d1 = data.filter((it: AnyObject) => it.type === HotWordType.choiceness);
        const d2 = data.filter((it: AnyObject) => it.type === HotWordType.ordinary);
        this.searchHotWords = [...d1, ...d2];
      }
    },
    async getUnusedCouponList(refresh?: boolean) {
      if (!this.coupon.unusedCouponList?.length || refresh) {
        this.coupon.unusedCouponList = await fetchCouponList(true);
      }
      return this.coupon.unusedCouponList;
    },
    async getUserCouponDetail(userCouponId: string, refresh?: boolean, removeNewTag = false) {
      if (!this.coupon.couponDetail || refresh) {
        const data = await fetchUserCouponDetail(userCouponId, removeNewTag);
        if (data) {
          this.coupon.couponDetail = data.coupon;
          this.coupon.userCoupon = data;
        }
      }
      console.log(`用户优惠券详情：`, this.coupon.couponDetail);

      return this.coupon.couponDetail;
    },
    async getCouponHold(couponId: string) {
      if (couponId) {
        const data = await fetchGetCouponHold(couponId);
        if (data) {
          this.coupon.couponDetail = data?.coupon;
          this.coupon.couponHold = data;
        }
        console.log(`用户优惠券持有：`, this.coupon.couponHold);
        return this.coupon.couponHold;
      }
    },
  },
});
